module.exports = __webpack_public_path__ + "static/00012.2304637a.jpg";